import { minimalHeaderFormConfigOptions } from 'platform/forms-system/src/js/patterns/minimal-header';
import FormFooter from 'platform/forms/components/FormFooter';
import { VA_FORM_IDS } from 'platform/forms/constants';
import { externalServices } from 'platform/monitoring/DowntimeNotification';
import environment from 'platform/utilities/environment';
import SubmissionErrorAlert from '../components/FormAlerts/SubmissionErrorAlert';
import GetHelpFooter from '../components/GetHelp';
import PreSubmitInfo from '../components/PreSubmitInfo';
import ConfirmationPage from '../containers/ConfirmationPage';
import IntroductionPage from '../containers/IntroductionPage';
import content from '../locales/en/content.json';
import manifest from '../manifest.json';
import { API_ENDPOINTS } from '../utils/constants';
import { chapters } from './chapters';
import submitTransformer from './submit-transformer';

const breadcrumbList = [
  { href: '/', label: '' },
  {
    href: '/forms',
    label: content['form-breadcrumb--forms'],
  },
  {
    href: '/forms/10-10cg',
    label: content['form-breadcrumb--1010cg'],
  },
  { href: '#content', label: content['app-title'] },
];

/** @type {FormConfig}  */
const formConfig = {
  // identity & routing
  formId: VA_FORM_IDS.FORM_10_10CG,
  rootUrl: manifest.rootUrl,
  urlPrefix: '/',

  // tracking & monitoring
  trackingPrefix: 'caregivers-10-10cg-',
  downtime: {
    dependencies: [externalServices.mvi, externalServices.carma],
  },

  // state management
  prefillEnabled: false,
  version: 0,

  // submission configuration
  submitUrl: environment.API_URL + API_ENDPOINTS.submission,
  preSubmitInfo: PreSubmitInfo,
  submissionError: SubmissionErrorAlert,
  transformForSubmit: submitTransformer,

  // form options
  formOptions: {
    useWebComponentForNavigation: true,
    filterInactiveNestedPageData: true,
  },

  // development settings
  dev: { disableWindowUnloadInCI: true },

  // header & display text
  ...minimalHeaderFormConfigOptions({
    homeVeteransAffairs: true,
    wrapping: true,
    breadcrumbList,
  }),
  title: content['app-title'],
  subTitle: content['app-subtitle'],

  // page structure
  introduction: IntroductionPage,
  confirmation: ConfirmationPage,
  footerContent: FormFooter,
  getHelp: GetHelpFooter,
  chapters,
};

export default formConfig;
